// src/components/strumenti/PitturaStanza.js — W442. Pittura per una stanza: superficie, litri e confezioni
import React from "react";
import { useCampi, Campo, Griglia, Risultato, Formula, Azzera, Avviso, fmt } from "./UiStrumento";
import { pitturaStanza } from "../../utils/calcoliStrumenti";

export default function PitturaStanza() {
  const { v, set, n, azzera } = useCampi({ l:"", p:"", h:"", ap:"", soff:false, mani:"2", resa:"", conf:"" });
  const r = pitturaStanza({ lunghezza:n("l"), larghezza:n("p"), altezza:n("h"), aperture:v.ap === "" ? 0 : n("ap"), soffitto:v.soff, mani:n("mani"), resa:n("resa"), confezione:n("conf") });
  return (
    <div>
      <Griglia colonne={3}>
        <Campo etichetta="Lunghezza (m)" valore={v.l} onChange={set("l")} placeholder="Es. 5"/>
        <Campo etichetta="Larghezza (m)" valore={v.p} onChange={set("p")} placeholder="Es. 4"/>
        <Campo etichetta="Altezza (m)" valore={v.h} onChange={set("h")} placeholder="Es. 2,7"/>
      </Griglia>
      <Griglia colonne={2}>
        <Campo etichetta="Porte e finestre da togliere (m²)" valore={v.ap} onChange={set("ap")} placeholder="Es. 3,6"/>
        <Campo etichetta="Numero di mani" valore={v.mani} onChange={set("mani")}/>
        <Campo etichetta="Resa per mano (m²/litro)" valore={v.resa} onChange={set("resa")} placeholder="Es. 10" aiuto="Dalla scheda del prodotto."/>
        <Campo etichetta="Litri per confezione (facoltativo)" valore={v.conf} onChange={set("conf")} placeholder="Es. 5"/>
      </Griglia>
      <label style={{ display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#374151", marginBottom:12, cursor:"pointer" }}>
        <input type="checkbox" checked={v.soff} onChange={set("soff")} style={{ accentColor:"#15803d" }}/> Pitturare anche il soffitto
      </label>
      {n("ap") > 0 && n("l") > 0 && n("p") > 0 && n("h") > 0 && !r && <Avviso>Le aperture superano la superficie delle pareti.</Avviso>}
      <Risultato settore="geometra" titolo="Pittura necessaria" valore={fmt(r?.litri, 1)} unita="litri"
        righe={r ? [["Superficie pareti", fmt(r.pareti, 2) + " m²"], ["Superficie totale da pitturare", fmt(r.superficie, 2) + " m²"], r.confezioni !== null && ["Confezioni", String(r.confezioni)]] : []}/>
      <Formula>Pareti = 2 × (lunghezza + larghezza) × altezza − aperture (+ soffitto = lunghezza × larghezza); litri = superficie × mani ÷ resa; confezioni arrotondate per eccesso. La resa reale dipende dal supporto: su muri nuovi o assorbenti è più bassa.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
